// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"0a6c1b4b","188":"1a913e2b","231":"9ffecd43","453":"94963f27","668":"b9482c85","721":"e35c806f","879":"98731a00","998":"5b327f67"}[chunkId] + ".chunk.js";
};